module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABB0lEQVRYR8XX7Q2CMBCA4SsMICM4QhMW0A10E1dxE51AFzhybuICUNMfTRrT0I+7A/5CeB9KclADOx9Go2+tHQDgSESUu784wFpru657GWMG59x9mqbbGkIUEMdDFBFXG2KAVBwAnoh4UV+BVNw591mW5UREX1UAJ+5hrFfAjbMAEvFmgFS8CSAZrwZIx6sAGvFigFa8CKAZLwKM4+gn2SFMs9IJl/sKhvPZQfQPAACa5/mcG7FiAP8K+r5/x6sgiciugH8STUQRQBNRDNBCVAE0ENUAaUQTQBLRDJBCsAASCDaAixABrCAeiHhV/SuOb56amJttTAIkRmy+NYsQ+21OSz/D4bofA/ERMNzPZMMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_left_active.png
// module id = fzgW
// module chunks = 1